module.exports = __webpack_public_path__ + "static/full-logo-ecb3c0e9d80a29dfcc82052addcd26d1.png";